// Copyright (C) 2017-2023 Smart code 203358507

const PaginationInput = require('./PaginationInput');

module.exports = PaginationInput;
